// extracted by mini-css-extract-plugin
export default {"imgbox":"Banner_imgbox__9mplM","center":"Banner_center__qD23y","text":"Banner_text__gkyue","btn":"Banner_btn__oQ2L7"};